// 0 - pendente / 1 - ativada / 2 - rejeitada / 3 - desativada

export const ESCOLA_STATUS_PENDENTE = 0;
export const ESCOLA_STATUS_ATIVADA = 1;
export const ESCOLA_STATUS_REJEITADA = 2;
export const ESCOLA_STATUS_DESATIVADA = 3;
